import { isSafeUrl } from './url-safety';

interface BoatDetailUrlFields {
  id?: string;
  make?: string;
  marketing_model?: string;
  detail_url?: string;
}

function buildDetailPath(make: string, marketingModel: string, id: string): string {
  const makeSlug = make.toLowerCase().replace(/\s+/g, '-');
  const modelSlug = marketingModel.toLowerCase().replace(/\s+/g, '-');
  return `/details/${makeSlug}/${modelSlug}/${id}`;
}

export function buildBoatDetailHref(data: BoatDetailUrlFields): string | undefined {
  const { id, make, marketing_model, detail_url } = data;
  if (id && make && marketing_model) return buildDetailPath(make, marketing_model, id);
  return isSafeUrl(detail_url) ? detail_url : undefined;
}
